import AppDispatcher from "dispatchers/app-dispatcher";
import _ from "lodash";
import { isTrialing } from "util/brand-stripe-belt-helper";
import { downloadFileFromUrl } from "util/download-helper";
import { H4 } from "visual-components/util/texts";

const ConfirmationDispatcher = _.extend({}, AppDispatcher, {
  check: (data) => {
    data.expand = true;
    store.dispatch({
      type: "UPDATE_ATTR",
      model: "confirmationModal",
      data: data,
    });
  },
  closeModal: () => {
    store.dispatch({
      type: "UPDATE_ATTR",
      model: "confirmationModal",
      data: {
        expand: false,
        loading: false,
        confirmText: "Send Entries",
      },
    });
  },
  exportEntries: (campaignId) => {
    // In development, trigger direct download
    if (process.env.NODE_ENV === "development") {
      const currentCampaign = store.getState().currentCampaign;

      // Trigger download using utility function
      downloadFileFromUrl(
        `/campaign-export-results/${campaignId}`,
        `${currentCampaign.name}_entries.zip`,
      );

      // Close modal and show success message
      store.dispatch({
        type: "UPDATE_ATTR",
        model: "confirmationModal",
        data: {
          loading: false,
          expand: false,
          confirmText: "Send Entries",
          disabled: false,
        },
      });

      toastr.success("Your download will begin shortly.", null, {
        timeOut: 5000,
        positionClass: "toast-bottom-center",
      });
      return;
    }

    // Production: Send email with CSV
    AppDispatcher.http({
      url: `/campaign-export-results/${campaignId}`,
      success: () => {
        store.dispatch({
          type: "UPDATE_ATTR",
          model: "confirmationModal",
          data: {
            loading: false,
            expand: false,
            confirmText: "Send Entries",
            disabled: false,
          },
        });

        const currentBrand = store.getState().currentBrand;
        const customer = store.getState().customer;
        const trialing = isTrialing(currentBrand, customer);

        if (trialing) {
          store.dispatch({
            type: "UPDATE_ATTR",
            model: "softEntriesPaywallModal",
            data: {
              open: true,
            },
          });
        } else {
          toastr.success(
            "Your request has been submitted. Please expect few minutes to receive email in your inbox.",
            null,
            { timeOut: 5000, positionClass: "toast-bottom-center" },
          );
        }
      },
      error: (err) => {
        if (err.responseText == "notEnough") {
          store.dispatch({
            type: "UPDATE_ATTR",
            model: "confirmationModal",
            data: {
              loading: false,
              confirmText: "Send Entries",
              disabled: false,
            },
          });
          store.dispatch({
            type: "UPDATE_ATTR",
            model: "notEnoughEntriesModal",
            data: {
              expand: true,
              campaignId: campaignId,
            },
          });
        }
      },
    });
  },
  checkDownloadEntries: (campaignId, location, filterWebbula) => {
    const isDevelopment = process.env.NODE_ENV === "development";
    const confirmationHeader = "Heads Up!";
    console.log("isDevelopment", isDevelopment, process.env.NODE_ENV);

    const confirmationCopy = (
      <span>
        <H4 multiline>
          {isDevelopment
            ? "Your download will begin shortly!"
            : "Your request has been successfully submitted!"}
          <br />
          <br />
          {isDevelopment ? (
            "The CSV file containing your entries will be downloaded directly to your computer."
          ) : (
            <>
              You will receive an email shortly containing your entries file attached. Please be
              advised, processing may take some time, as Dojo will verify the entries and review for
              accuracy.
            </>
          )}
          <br />
          <br />
          Should you have any inquiries, kindly contact us at{" "}
          <a rel="noopener noreferrer" href="mailto:hello@dojomojo.com">
            hello@dojomojo.com
          </a>
          .
        </H4>
      </span>
    );

    ConfirmationDispatcher.check({
      header: confirmationHeader,
      copy: confirmationCopy,
      confirmText: "Send Entries",
      action: () => {
        const { confirmationModal } = store.getState();
        if (confirmationModal.disabled) {
          return;
        }

        store.dispatch({
          type: "UPDATE_ATTR",
          model: "confirmationModal",
          data: {
            expand: true,
            loading: false,
            confirmText: "Please wait...",
            disabled: true,
          },
        });
        ConfirmationDispatcher.exportEntries(campaignId);
      },
      location: location,
    });
  },
});

export default ConfirmationDispatcher;
